export default {
	default: [''],
	icon: ['segmented-control--only-icon'],
	leftLabel: ['segmented-control--left-label']
};
